import { parse } from "tldts";

export function normalizeUrl(rawUrl: string): string | null {
  let normalizedUrl = rawUrl;

  if (
    !normalizedUrl.startsWith("http://") &&
    !normalizedUrl.startsWith("https://")
  ) {
    normalizedUrl = `https://${normalizedUrl}`;
  }

  const parsed = parse(normalizedUrl, {
    // Tell tlds we're only providing full urls, instead of just hostnames:
    mixedInputs: false,
  });

  /**
   * Ensure we extracted a domain. This has the added effect of blocking the use of
   * bare IP addresses:
   */
  if (!parsed.domain) {
    return null;
  }

  /**
   * Ensure we have a valid ICANN-listed tld:
   */
  if (!parsed.isIcann) {
    return null;
  }

  /**
   * Finally, ensure we have a valid URL, and use the url class to normalize
   * it to a consistent format:
   */
  try {
    const asUrl = new URL(normalizedUrl);
    return asUrl.toString();
  } catch (_err) {
    return null;
  }
}
